import React from 'react';
import './VerticalDivider.scss';

const VerticalDivider = ({ className = '' }) => (
    <div className={`vertical-divider ${className}`} />
);

export default VerticalDivider;
